/* Signora (2 Nov 2026): "Price, low to high / high to low" by the price the cards show.
   Shopify's own price sort uses each product's cheapest variant (Silver), while every card, the search dropdown and
   og:price show the cheapest GOLD variant (snippets/sjw-from-price). With a price sort in the URL this script reads
   the whole collection's gold "From" prices from the collection.sjw-from view (50 per request, same filters), orders
   them, and fills the grid with the matching cards taken from Shopify's own section pages, so the cards are the
   theme's own markup. The theme's "Load more" / page links are replaced by one "Load more" for this order.
   Any failure leaves Shopify's native order on the page. */
(function () {
  'use strict';
  var DIR = { 'price-ascending': 1, 'price-descending': -1 };
  var run = 0;
  var state = null;

  function sortBy() { return new URL(location.href).searchParams.get('sort_by') || ''; }
  function parts() {
    var section = document.querySelector('section.js-collection');
    var wrap = section && section.querySelector('.js-grid-wrapper');
    return section && wrap ? { section: section, wrap: wrap } : null;
  }
  function baseParams() {
    var p = new URL(location.href).searchParams;
    p.delete('page'); p.delete('section_id'); p.delete('view');
    return p;
  }
  async function getText(url) {
    var r = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
    if (!r.ok) throw new Error('price sort ' + r.status);
    return r.text();
  }
  async function readPrices() {
    var p = baseParams(); p.set('view', 'sjw-from');
    var url = function (n) { var q = new URLSearchParams(p); q.set('page', String(n)); return location.pathname + '?' + q; };
    var first = JSON.parse(await getText(url(1)));
    var items = first.items.slice();
    /* 50 products per request: a bigger page of ~100-variant rings is over Shopify's render limit (HTTP 500). */
    for (var n = 2; n <= Math.min(first.pages || 1, 40); n += 4) {
      var batch = [];
      for (var m = n; m < n + 4 && m <= Math.min(first.pages || 1, 40); m++) batch.push(getText(url(m)).then(JSON.parse));
      (await Promise.all(batch)).forEach(function (d) { items = items.concat(d.items); });
    }
    return items.map(function (it, i) { return { h: it[0], p: it[1], i: i }; });
  }
  /* Cards come from Shopify's own section pages in the native order, so a product's native position tells which page holds it. */
  async function cardsFor(list) {
    var need = {};
    list.forEach(function (it) { if (!state.cards[it.h]) need[Math.floor(it.i / state.size) + 1] = 1; });
    var pages = Object.keys(need).filter(function (n) { return !state.fetched[n]; });
    for (var k = 0; k < pages.length; k += 4) {
      await Promise.all(pages.slice(k, k + 4).map(async function (n) {
        state.fetched[n] = 1;
        var q = baseParams(); q.set('page', n); q.set('section_id', state.sectionId);
        var doc = new DOMParser().parseFromString(await getText(location.pathname + '?' + q), 'text/html');
        doc.querySelectorAll('.js-grid-wrapper > [data-sjw-product-handle]').forEach(function (el) {
          if (!state.cards[el.dataset.sjwProductHandle]) state.cards[el.dataset.sjwProductHandle] = el;
        });
      }));
    }
    /* A grid banner can shift a product to the neighbouring page; look there once. */
    var missing = list.filter(function (it) { return !state.cards[it.h]; });
    if (missing.length && !state.retried) { state.retried = true; missing.forEach(function (it) { var n = Math.floor(it.i / state.size) + 1; [n - 1, n + 1].forEach(function (m) { if (m > 0) delete state.fetched[m]; }); }); return cardsFor(list); }
    return list.map(function (it) { return state.cards[it.h]; }).filter(Boolean);
  }
  function moreButton(show) {
    var box = state.wrap.parentNode.querySelector('.sjw-price-more');
    if (!show) { if (box) box.remove(); return; }
    if (!box) {
      box = document.createElement('div');
      box.className = 'sjw-price-more collection__lazy-load-button-wrapper';
      box.innerHTML = '<button type="button" class="button button--secondary collection__load-more-button">Load more</button>';
      state.wrap.parentNode.insertBefore(box, state.wrap.nextSibling);
      box.firstChild.addEventListener('click', function () { showNext(this); });
    }
  }
  async function showNext(btn) {
    var my = run;
    var next = state.order.slice(state.shown, state.shown + state.size);
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      var els = await cardsFor(next);
      if (my !== run) return;
      var frag = document.createDocumentFragment();
      els.forEach(function (el) { frag.appendChild(document.importNode(el, true)); });
      state.wrap.appendChild(frag);
      state.shown += next.length;
    } finally { if (btn) btn.removeAttribute('aria-busy'); }
    moreButton(state.shown < state.order.length);
  }
  function hideNative(section) {
    section.querySelectorAll('.collection__lazy-load-button-wrapper:not(.sjw-price-more), .collection__pagination-wrapper').forEach(function (el) { el.hidden = true; el.style.display = 'none'; });
  }
  async function apply() {
    var dir = DIR[sortBy()];
    var p = parts();
    if (!dir || !p) return;
    var key = location.search;
    if (p.wrap.dataset.sjwPriceSorted === key) return;
    var my = ++run;
    p.wrap.dataset.sjwPriceSorted = key;
    p.section.classList.add('sjw-price-sorting');
    p.wrap.setAttribute('aria-busy', 'true');
    try {
      state = { wrap: p.wrap, sectionId: p.section.id, size: parseInt(p.wrap.dataset.pageSize || '20', 10) || 20, cards: {}, fetched: {}, shown: 0, retried: false };
      var page = parseInt(new URL(location.href).searchParams.get('page') || '1', 10) || 1;
      state.fetched[page] = 1;
      p.wrap.querySelectorAll(':scope > [data-sjw-product-handle]').forEach(function (el) { state.cards[el.dataset.sjwProductHandle] = el; });
      var items = await readPrices();
      if (my !== run) return;
      items.sort(function (a, b) { return (a.p - b.p) * dir || a.i - b.i; });
      state.order = items;
      state.shown = (page - 1) * state.size;
      var first = items.slice(state.shown, state.shown + state.size);
      var els = await cardsFor(first);
      if (my !== run || !els.length) return;
      var frag = document.createDocumentFragment();
      els.forEach(function (el) { frag.appendChild(el.ownerDocument === document ? el : document.importNode(el, true)); });
      p.wrap.replaceChildren(frag);
      state.shown += first.length;
      hideNative(p.section);
      moreButton(state.shown < items.length);
    } catch (e) {
      /* keep Shopify's order */
    } finally {
      if (my === run) { p.section.classList.remove('sjw-price-sorting'); p.wrap.setAttribute('aria-busy', 'false'); }
    }
  }

  var css = document.createElement('style');
  css.textContent = '.sjw-price-sorting .js-grid-wrapper{opacity:.45;transition:opacity .2s}';
  document.head.appendChild(css);

  var t;
  function soon() { clearTimeout(t); t = setTimeout(apply, 60); }
  /* The theme re-renders the section on sort and filter changes; run again whenever the grid is new. */
  new MutationObserver(function () {
    if (location.search.indexOf('sort_by=price-') < 0) return;
    var p = parts();
    if (p && p.wrap.dataset.sjwPriceSorted !== location.search) soon();
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();
